import {SearchError} from './SearchError.js'

export class InvalidContextSearchError extends SearchError {}
